import { ResolveFn } from '@angular/router';
import {inject} from "@angular/core";
import { DiscoverResourcesService } from '../discoverResources/discover-resources.service';

export const resourceOptionsResolver: ResolveFn<boolean> = (route, state) => {
  return inject(DiscoverResourcesService).getOptions();
};
